import * as CurrencyCodes from 'self-service-api/constants/CurrencyCodes';
import { createSelector } from 'reselect';

const customerCurrencyCodeSelector = ({
  customerCurrencyCode
}) => customerCurrencyCode;

export const activeCurrencySelector = state => {
  // TODO: This hack is temporary. The types of activeCurrencyCode and customerCurrencyCode are not
  // what we would expect. Check where the type is breaking down.
  const {
    activeCurrencyCode
  } = state;
  const customerCurrencyCode = customerCurrencyCodeSelector(state);

  if (customerCurrencyCode) {
    return customerCurrencyCode;
  }

  if (!CurrencyCodes[activeCurrencyCode]) return CurrencyCodes.USD;
  return activeCurrencyCode;
};
export const availableCurrenciesSelector = createSelector(customerCurrencyCodeSelector, customerCurrencyCode => {
  if (customerCurrencyCode) return [customerCurrencyCode];
  return Object.values(CurrencyCodes);
});